module.exports = __webpack_public_path__ + "img/case-study-bg-left.e56eb43e.svg";